import React from "react";

import { Skeleton } from "@mui/material";

import {
  Container,
  CoverImageContainer,
  PropertyInfosContainer,
} from "./style";

export default function PropertyCard() {
  return (
    <Container>
      <CoverImageContainer>
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={"100%"}
          style={{
            borderTopLeftRadius: "8px",
          }}
        />
      </CoverImageContainer>
      <PropertyInfosContainer>
        <Skeleton height={50} />
        <Skeleton />
        <Skeleton />
        <Skeleton />
      </PropertyInfosContainer>
    </Container>
  );
}
